import React, { Fragment } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { addMediaFileToNote, resetFileUpload } from 'data/medias/actions'
import { getFileUploadByMeta } from 'data/medias/selectors'

import FileUploading from './FileUploading'

function FileUploadWrapper(props) {
  const isUploading = Boolean(props.fileUpload)

  return (
    <Fragment>
      {props.children}
      {isUploading && <FileUploading {...props} />}
    </Fragment>
  )
}

const enhance = compose(
  connect(
    (state, props) => ({
      fileUpload: getFileUploadByMeta(state, 'blockKey', props.node.key),
    }),
    {
      addMediaFileToNote,
      resetFileUpload,
    }
  )
)

export default enhance(FileUploadWrapper)
